export default "<p>add-placement-reading works!</p>\n"